import React from 'react';

/**
 * Renderiza el bloque DepthProfileView de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function DepthProfileView({
  v
}) {
  return v.depIsProf ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "maxWidth": "57.291667vw",
      "width": "100%",
      "alignSelf": "center"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.925926vh",
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, React.createElement("span", {
    style: {
      "whiteSpace": "nowrap"
    }
  }, v.text("Segundo carril")), React.createElement("div", {
    style: {
      "flex": "none",
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.depLanes || []).map((m, index44) => React.createElement(React.Fragment, {
    key: index44
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "whiteSpace": "nowrap",
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.277778vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color
    }
  }, v.text(m.label)))))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "2.291667vw minmax(0,1fr) 3.333333vw 1.770833vw 1.770833vw minmax(0,1fr) 2.291667vw",
      "gap": "0.555556vh",
      "alignItems": "end",
      "paddingBottom": "0.37037vh"
    }
  }, React.createElement("span", {
    style: {
      "gridColumn": "1 / span 2",
      "font": "600 1.018519vh 'IBM Plex Sans',sans-serif",
      "letterSpacing": "0.05em",
      "textTransform": "uppercase",
      "color": "#8793a6"
    }
  }, v.text("◂ % del tiempo sin alimentar")), React.createElement("span", {}, null), React.createElement("span", {
    style: {
      "font": "600 1.018519vh 'IBM Plex Sans',sans-serif",
      "letterSpacing": "0.05em",
      "textTransform": "uppercase",
      "color": "oklch(0.66 0.2 25)",
      "textAlign": "center",
      "fontSize": "0.925926vh"
    }
  }, v.text("Alarm.")), React.createElement("span", {
    style: {
      "font": "600 1.018519vh 'IBM Plex Sans',sans-serif",
      "letterSpacing": "0.05em",
      "textTransform": "uppercase",
      "color": "#b8c1ce",
      "textAlign": "center",
      "fontSize": "0.925926vh"
    }
  }, v.text(v.depLaneLab)), React.createElement("span", {
    style: {
      "gridColumn": "6 / span 2",
      "font": "600 1.018519vh 'IBM Plex Sans',sans-serif",
      "letterSpacing": "0.05em",
      "textTransform": "uppercase",
      "color": "oklch(0.72 0.15 150)",
      "textAlign": "right"
    }
  }, v.text("% del tiempo alimentando ▸"))), v.text("\n        "), React.createElement("div", {
    "onMouseLeave": v.depPLeave,
    style: {
      "flex": "0 1 auto",
      "minHeight": "0",
      "position": "relative",
      "display": "flex",
      "flexDirection": "column"
    }
  }, v.text("\n          "), React.createElement("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "bottom": "0",
      "left": "calc(2.604167vw + (100% - 11.979167vw) / 2 + 0.15625vw)",
      "width": "0.052083vw",
      "background": "rgba(46,179,238,0.1)",
      "pointerEvents": "none"
    }
  }, null), v.text("\n          "), (v.depProf || []).map((p, index45) => React.createElement(React.Fragment, {
    key: index45
  }, React.createElement("div", {
    "onMouseEnter": p.enter,
    style: {
      "flex": "0 1 1.458333vw",
      "height": "2.592593vh",
      "minHeight": "1.111111vh",
      "display": "grid",
      "gridTemplateColumns": "2.291667vw minmax(0,1fr) 3.333333vw 1.770833vw 1.770833vw minmax(0,1fr) 2.291667vw",
      "gap": "0.555556vh",
      "alignItems": "center",
      "background": p.bg,
      "borderRadius": "0.277778vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "1.111111vh 'IBM Plex Mono',monospace",
      "color": "#8793a6"
    }
  }, v.text(p.iP)), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "flex-end",
      "height": "60%",
      "maxHeight": "1.018519vh"
    }
  }, React.createElement("div", {
    style: {
      "width": p.iW,
      "background": "#5a667a",
      "borderRadius": "0.092593vh"
    }
  }, null)), React.createElement("span", {
    style: {
      "textAlign": "center",
      "font": p.fw + " 1.203704vh 'IBM Plex Mono',monospace",
      "color": p.labC
    }
  }, v.text(p.lab)), React.createElement("div", {
    style: {
      "height": "80%",
      "maxHeight": "1.851852vh",
      "borderRadius": "0.277778vh",
      "background": p.aBg,
      "border": p.aBd
    }
  }, null), React.createElement("div", {
    style: {
      "height": "80%",
      "maxHeight": "1.851852vh",
      "borderRadius": "0.277778vh",
      "background": p.lBg,
      "border": p.aBd
    }
  }, null), React.createElement("div", {
    style: {
      "display": "flex",
      "height": "60%",
      "maxHeight": "1.018519vh"
    }
  }, React.createElement("div", {
    style: {
      "width": p.fW,
      "background": p.fBg,
      "borderRadius": "0.092593vh"
    }
  }, null)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0",
      "textAlign": "right"
    }
  }, v.text(p.fP))))), v.text("\n          "), v.depPTip.on ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": "calc(50% + 3.125vw)",
      "top": v.depPTip.top,
      "transform": "translateY(-50%)",
      "zIndex": "40",
      "width": "13.020833vw",
      "background": "rgba(6,14,28,0.96)",
      "border": "0.092593vh solid rgba(46,179,238,0.35)",
      "borderRadius": "0.740741vh",
      "padding": "0.925926vh 1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.462963vh",
      "pointerEvents": "none",
      "boxShadow": "0 0.740741vh 2.222222vh rgba(0,0,0,0.45)"
    }
  }, React.createElement("div", {
    style: {
      "fontWeight": "600",
      "fontSize": "1.203704vh",
      "color": "#e4e9f0",
      "paddingBottom": "0.37037vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.14)"
    }
  }, v.text(v.depPTip.title)), (v.depPTip.rows || []).map((r, index46) => React.createElement(React.Fragment, {
    key: index46
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.925926vh",
      "fontSize": "1.111111vh"
    }
  }, React.createElement("span", {
    style: {
      "color": r.c,
      "whiteSpace": "nowrap"
    }
  }, v.text(r.l)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap"
    }
  }, v.text(r.v))))))) : null, v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "alignItems": "center",
      "gap": "0.740741vh 1.666667vh",
      "paddingTop": "0.925926vh",
      "borderTop": "0.092593vh solid rgba(46,179,238,0.1)",
      "fontSize": "1.018519vh",
      "color": "#8793a6"
    }
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("b", {
    style: {
      "color": "oklch(0.66 0.2 25)",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em"
    }
  }, v.text("Alarmas")), React.createElement("span", {
    style: {
      "width": "3.125vw",
      "height": "0.555556vh",
      "borderRadius": "0.185185vh",
      "background": "linear-gradient(90deg,oklch(0.66 0.2 25 / 0.3),oklch(0.66 0.2 25))"
    }
  }, null), v.text(v.depAlMax)), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("b", {
    style: {
      "color": "#b8c1ce",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em"
    }
  }, v.text(v.depLaneLeg)), React.createElement("span", {
    style: {
      "width": "3.125vw",
      "height": "0.555556vh",
      "borderRadius": "0.185185vh",
      "background": "linear-gradient(90deg,rgba(184,193,206,0.15),rgba(184,193,206,0.87))"
    }
  }, null), v.text(v.depLaneMax)), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "rgba(46,179,238,0.05)",
      "border": "0.092593vh solid rgba(46,179,238,0.15)"
    }
  }, null), v.text("Cero medido")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "repeating-linear-gradient(135deg,oklch(0.72 0.15 150) 0 0.277778vh,transparent 0.277778vh 0.555556vh)"
    }
  }, null), v.text("Poca exposición (< 3 % del tiempo): el conteo subestima")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "repeating-linear-gradient(135deg,#2a3446 0 0.277778vh,transparent 0.277778vh 0.555556vh)"
    }
  }, null), v.text("Sin dato"))), v.text("\n      "))) : null;
}
